{
  "#ESL": {
    "TITLE": "ESL",
    "ESL_CODE": {
      "MANUAL_INPUT": "Manual Input",
      "PLACEHOLDER": "ESL Code",
      "SUBMIT": "Confirm",
      "OR": "Or",
      "SCAN_HEADER": "Scan ESL",
      "SCAN_DESCRIPTION": "Search ESL using the integrated scanner"
    },
    "ASSOCIATE_ITEMS": {
      "TITLE": "Associate ESL",
      "MANUAL_INPUT": "Manual Input",
      "PLACEHOLDER": "Article Number",
      "OR": "Or",
      "SCAN_HEADER": "Scan Article",
      "SCAN_DESCRIPTION": "Search article using the integrated scanner",
      "SUBMIT": "Save",
      "ESL": "ESL Code",
      "ITEMS": "Articles",
      "ADD": "Add",
      "SUCCESS": "The article has been assigned to the ESL",
      "NO_ITEMS": "No articles have been added yet"
    },
    "ASSOCIATE": {
      "TITLE": "Associate ESL"
    },
    "DISSOCIATE": {
      "TITLE": "Dissociate ESL",
      "SCAN": "Scan",
      "ESL": "ESL Code",
      "SUBMIT": "Remove Assignment",
      "SUCCESS": "The assignment of {{esl}} has been removed"
    },
    "DIALOGS": {
      "ITEM": {
        "TITLE": "Select Article",
        "ITEM": "Article",
        "SUBMIT": "Select"
      }
    },
    "PREVIEW": {
      "TITLE": "Preview",
      "DESCRIPTION": "Should the assignment to the label be made?",
      "CANCEL": "Cancel",
      "OK": "Assign"
    },
    "CONFIGURATION": "Configuration",
    "COUNT": "Quantity",
    "VARIANT": "Variant",
    "PREVIEW_QUESTION": "This option defines whether a preview is displayed and a confirmation is required."
  }
}
